/**
 * Loads and decodes an image before it is shown, so a swap or reveal never paints a half-loaded frame.
 * A load or decode failure must reach the generation error handler.
 */
export const preloadImage = (url: string): Promise<void> => new Promise((resolve, reject) => {
  const image = new Image()
  const done = () => resolve()
  image.onload = () => {
    if (typeof image.decode === 'function') {
      image.decode().then(done, reject)
    } else {
      done()
    }
  }
  image.onerror = () => reject(new Error('Failed to load image'))
  image.src = url
})
